export const getLocalDateFromTimestamp = timestamp => {
  if (!timestamp) return null
  const date = new Date(timestamp)

  const day = date.getDate()
  const month = date.toLocaleString('default', { month: 'short' })
  const year = date.getFullYear()

  return `${day} ${month}, ${year}`
}

export const nth = function (d) {
  if (d > 3 && d < 21) return 'th'
  switch (d % 10) {
    case 1:
      return 'st'
    case 2:
      return 'nd'
    case 3:
      return 'rd'
    default:
      return 'th'
  }
}

export function getCurrentDate() {
  const date = new Date()
  const day = date.getDate()
  const month = date.toLocaleString('en-US', { month: 'long' })
  const year = date.getFullYear()
  // This arrangement can be altered based on how we want the date's format to appear.
  const currentDate = `${day}${nth(day)} ${month} ${year}`
  return currentDate
}

export const monthNameDateYear = createdAtString => {
  const date = new Date(createdAtString)
  const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' }
  const formattedDate = date.toLocaleDateString('en-US', options)
  return formattedDate
}

type FormatDateOptions = {
  timeWithMinutes?: boolean
  timeHourOnly?: boolean
  formattedDay?: boolean
  locale?: string
  hour12?: boolean
  timeZone?: string
}

export function formatDate(date: Date, options: FormatDateOptions = {}): string {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
    throw new Error('Invalid Date')
  }

  const {
    timeWithMinutes = false,
    timeHourOnly = false,
    formattedDay = false,
    locale = 'en-US',
    hour12 = true,
    timeZone = 'Asia/Kolkata',
  } = options

  const parts: string[] = []

  if (timeWithMinutes) {
    // "3:45 PM"
    parts.push(
      date.toLocaleTimeString(locale, {
        hour: 'numeric',
        minute: '2-digit',
        hour12,
        timeZone,
      })
    )
  }

  if (timeHourOnly) {
    // "3 PM"
    parts.push(
      date.toLocaleTimeString(locale, {
        hour: 'numeric',
        hour12,
        timeZone,
      })
    )
  }

  if (formattedDay) {
    const day = Number(
      date.toLocaleString(locale, {
        day: 'numeric',
        timeZone,
      })
    ) // -> 21

    const month = date.toLocaleString(locale, {
      month: 'long',
      timeZone,
    }) // -> January

    // "January 21st"
    parts.push(`${month} ${day}${nth(day)}`)
  }

  // Combined example:
  // formatDate(date, { timeHourOnly: true, formattedDay: true })
  // → "3 PM January 21st"
  return parts.join(' ')
}
